import { get, post } from '@/api';
import type { ISimulation } from '@/components/forms/interface/ISimulation';

export async function postPerson(data: any) {
  return (await post('api/widget/person', data)).body.data;
}

export async function getPerson() {
  return (await get('api/widget/person')).body.data;
}

export async function findPerson(id) {
  return (await get(`api/widget/person/${id}`)).body.data;
}

export async function checkHasPassword() {
  return (await post('api/widget/person/has-password')).body.data;
}

export async function getSimulation(simulationId: number) {
  return (await get(`api/widget/person/simulation/${simulationId}`)).body.data;
}

export async function getLastSimulation() {
  try {
    if (localStorage.getItem('pravaler_token')) {
      return (await get('api/widget/person/last-simulation')).body.data as ISimulation;
    }
  } catch (error) {
    return false;
  }
}

export async function checkValidStudent() {
  return (await post('api/widget/person/check-valid-student')).body.data;
}
